export const getTimeFilterInput = (filter: any): number => {
    switch (filter) {
        case "All Sessions":
            return 0;
        case "Recent and Upcoming Sessions":
            return 1;
        case "Past Sessions":
            return 2;
        default:
            return 1;
    }
}